import React, { useState, useEffect } from 'react';
import { Link, useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaChartBar, FaSignOutAlt, FaBars, FaUserCircle, FaKey, FaIdBadge, FaUserTie, FaClipboardList } from 'react-icons/fa';
import './Layout.css';

const Layout: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    if (sidebarOpen && isMobile) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [sidebarOpen]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="layout-container">
      <button
        className="btn btn-dark d-md-none sidebar-toggle-btn"
        onClick={handleToggleSidebar}
        aria-label="Toggle sidebar"
      >
        <FaBars />
      </button>

      <div className={`sidebar-overlay ${sidebarOpen ? 'open' : ''}`} onClick={closeSidebar}></div>
      
      <div className={`sidebar-container bg-dark text-white ${sidebarOpen ? 'open' : ''}`}>
        <div className="p-3 d-flex flex-column h-100">
          <h4 className="text-center mb-4">Sistema de Control</h4>
          <div style={{marginBottom: '0.2rem', display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
            {user?.name && (
              <div className="fw-bold" style={{marginBottom: '2px', fontSize: '1.05rem', display: 'flex', alignItems: 'center', gap: '4px'}}>
                <FaUserCircle style={{ fontSize: '1.1em', marginRight: 2, opacity: 0.85 }} />
                {user.name}
              </div>
            )}
            <span className={`badge ${user?.role === 'administrador' ? 'bg-primary' : user?.role === 'supervisor' ? 'bg-warning text-dark' : user?.role === 'backoffice' ? 'bg-info' : 'bg-secondary'}`} style={{fontSize: '0.91rem', padding: '2px 8px', lineHeight: 1, display: 'flex', alignItems: 'center', gap: '3px'}}>
              {user?.role === 'administrador'
                ? <FaKey style={{ fontSize: '1em', marginRight: 2, opacity: 0.85 }} />
                : user?.role === 'supervisor'
                  ? <FaKey style={{ fontSize: '1em', marginRight: 2, opacity: 0.85 }} />
                  : user?.role === 'backoffice'
                    ? <FaIdBadge style={{ fontSize: '1em', marginRight: 2, opacity: 0.85 }} />
                    : <FaIdBadge style={{ fontSize: '1em', marginRight: 2, opacity: 0.85 }} />}
              {user?.role === 'administrador' ? 'Administrador' : user?.role === 'supervisor' ? 'Supervisor' : user?.role === 'backoffice' ? 'Backoffice' : 'Vendedor'}
            </span>
          </div>
          <hr />
          <nav className="nav flex-column flex-grow-1">
            <Link to="/dashboard" className={`nav-link text-white${location.pathname === '/dashboard' ? ' active' : ''}`} onClick={closeSidebar}>
              <FaChartBar className="me-2" /> Dashboard
            </Link>
            {user?.role === 'administrador' && (
              <Link to="/users" className={`nav-link text-white${location.pathname === '/users' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaUserTie className="me-2" /> Usuarios
              </Link>
            )}
            {(user?.role === 'administrador' || user?.role === 'supervisor' || user?.role === 'backoffice') && (
              <Link to="/reports" className={`nav-link text-white${location.pathname === '/reports' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaChartBar className="me-2" /> Reportes
              </Link>
            )}
            {(user?.role === 'administrador' || user?.role === 'supervisor' || user?.role === 'backoffice') && (
              <Link to="/advance-general" className={`nav-link text-white${location.pathname === '/advance-general' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaBars className="me-2" /> Avance General
              </Link>
            )}
            {(user?.role === 'administrador' || user?.role === 'supervisor') && (
              <Link to="/winbo-orders" className={`nav-link text-white${location.pathname === '/winbo-orders' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaClipboardList className="me-2" /> Órdenes WinBO
              </Link>
            )}
          </nav>
          <button
            onClick={handleLogout}
            className="nav-link text-white border-0 bg-transparent mt-auto text-start"
            style={{ cursor: 'pointer' }}
          >
            <FaSignOutAlt className="me-2" /> Cerrar Sesión
          </button>
        </div>
      </div>
      
      <div className="main-content-area less-padding-top">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;

